import React, { useEffect, useRef, useState } from "react";
import './SliderFilled.scss';
import { IconType } from "react-icons";

type SliderFilledProps = {
    className?: string,
    value: number,
    icon: IconType,
    disabled?: boolean,
    onChange?: (value: number) => void,
};

function SliderFilled(props: SliderFilledProps) {
    const [isPressed, setPressed] = useState<boolean>(false);
    const [value, setValue] = useState<number>(props.value);
    const [timerId, setTimerId] = useState<any>(-1);

    const ref = useRef<HTMLDivElement>(null);

    const changeValue = (leftPosition: number) => {
        if(!ref.current || props.disabled)
            return;
        const x: number = leftPosition-ref.current.getBoundingClientRect().left;
        const formattedValue: number = Math.round(Math.min(Math.max(x/ref.current.getBoundingClientRect().width*100, 0), 100));
        setValue(formattedValue);
    };

    const handleMouseDown = (e: React.MouseEvent) => {
        if(props.disabled) {
            return;
        }
        setPressed(true);
        changeValue(e.pageX);
    };

    const handleTouchStart = (e: React.TouchEvent) => {
        if(props.disabled) {
            return;
        }
        setPressed(true);
        changeValue(e.changedTouches[0].pageX);
    };

    const handlePointerUp = () => {
        if(props.disabled) {
            return;
        }
        setPressed(false);
        clearTimeout(timerId);
        setTimerId(0);
        if(props.onChange) {
            props.onChange(Math.round(value));
        }
    };

    const handleMouseMove = (e: React.MouseEvent) => {
        if(!isPressed || !ref.current || props.disabled)
            return;
        changeValue(e.pageX);
    };

    const handleTouchMove = (e: React.TouchEvent) => {
        if(!isPressed || !ref.current || props.disabled)
            return;
        changeValue(e.changedTouches[0].pageX);
    };

    return (
        <div ref={ref} className={`rangefilled-container ${props.className ?? ''} ${props.disabled ? 'disabled' : ''}`}
            onMouseDown={handleMouseDown}
            onMouseUp={handlePointerUp}
            onMouseMove={handleMouseMove}
            onTouchStart={handleTouchStart}
            onTouchEnd={handlePointerUp}
            onTouchMove={handleTouchMove}>
            <div className="rangefilled-icon">
                {React.createElement(props.icon, { size: '1.3rem' })}
            </div>
            <div className="rangefilled-bar" style={{width: `${value}%`}}></div>
            {/* <input type="range" onChange={handleChange} value={props.value}/> */}
        </div>
    );
}

export default SliderFilled;
